import posthog from 'posthog-js';
import { AnalyticsProvider } from './types';

// PostHog-backed analytics. Reads the posthog-js singleton initialized in
// main.ts. All calls are wrapped so a misconfigured/unloaded SDK can never
// throw into a click handler.
export const posthogAnalytics: AnalyticsProvider = {
  name: 'posthog',

  track(event, properties) {
    try {
      posthog.capture(event, properties);
    } catch (err) {
      console.error('[analytics] track failed', event, err);
    }
  },

  identify(distinctId, properties) {
    try {
      posthog.identify(distinctId, properties);
    } catch (err) {
      console.error('[analytics] identify failed', err);
    }
  },

  register(superProperties) {
    try {
      posthog.register(superProperties);
    } catch (err) {
      console.error('[analytics] register failed', err);
    }
  },

  reset() {
    try {
      posthog.reset();
    } catch (err) {
      console.error('[analytics] reset failed', err);
    }
  },

  isReady() {
    return !!(posthog as any).__loaded;
  },
};
